import { Table, TableProps } from '@round/ui-kit';
import { RowData } from '@tanstack/react-table';
import styles from './WrapperTable.module.css';
import cn from 'classnames';

const WrapperTable = <T extends RowData>(props: TableProps<T>) => {
    const noDataLabel = props.noDataLabel ? <div className={styles.noDataLabel}>{props.noDataLabel}</div> : undefined;

    return <Table {...props} className={cn(styles.table, props.className)} noDataLabel={noDataLabel} />;
};

export default WrapperTable;
